import { lazyInitializeCalendarChannelPicker } from 'owa-calendar-channel-picker';
import { orchestrator } from 'satcheljs';
import { isConnectedAccount } from 'owa-accounts-store';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { calendarCacheInitializedForAccount } from 'owa-calendar-cache-loader';

orchestrator(calendarCacheInitializedForAccount, actionMessage => {
    const { userId } = actionMessage;
    const event = getComposeEvent(null /* formId */);
    if (userId && event && isConnectedAccount(userId)) {
        lazyInitializeCalendarChannelPicker.importAndExecute(event);
    }
});
